import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getPatentProofsByOwnerOptions } from '@/module/Author/Patent/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface PatentOwnerProofListProps {
  patentId: Id;
  userId: Id;
}

export function PatentOwnerProofList({ patentId, userId }: PatentOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getPatentProofsByOwnerOptions(patentId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="patent"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
